import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import EntityEditFrom from './../../elements/entities/form';
import Loading from "../../elements/loading";
import EntityAdd from './../../elements/entities/widget/entity_add';

class EntityCreate extends Component {
	render (){
		const { entities/*, municipalities*/,status } = this.props;
		return(
			entities.isFetching || status.isFetching ? <Loading/>:<EntityEditFrom {...this.props}/>
		);
	}

	componentWillMount() {
		this.props.resetEntity();
		//this.props.fetchStatus(1);
	}
}

//export default BaseLayout(EntityCreate, {title: `Crear Entidad`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}});
export default BaseLayout(EntityCreate, {
	title: `Crear Entidad`,
	subnav: {
		icon: 'fa-map',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <EntityAdd />
			}
		]
	}
});




// WEBPACK FOOTER //
// ./src/layouts/entities/create.jsx